import type {
	RecentTimelineItemTypeFilterEnum,
	TimelineHorizonEnum,
	TimelineItemCategoryEnum,
	UpcomingTimelineItemTypeFilterEnum,
} from "web_myplann/Infrastructure/Api/Api";

const NOTIFICATION_CENTER_ROOT = ["myplann", "notification-center"] as const;

export const NotificationCenterKeys = {
	all: NOTIFICATION_CENTER_ROOT,
	upcoming: (
		horizon: TimelineHorizonEnum,
		type: UpcomingTimelineItemTypeFilterEnum,
	) => [...NotificationCenterKeys.all, "upcoming", horizon, type] as const,
	upcomingPreview: (
		horizon: TimelineHorizonEnum,
		type: UpcomingTimelineItemTypeFilterEnum,
		dateTo: string | undefined,
		limit: number,
	) =>
		[
			...NotificationCenterKeys.all,
			"upcoming-preview",
			horizon,
			type,
			dateTo,
			limit,
		] as const,
	resolvingNow: (type?: UpcomingTimelineItemTypeFilterEnum, limit?: number) =>
		[...NotificationCenterKeys.all, "resolving-now", type, limit] as const,
	recentAll: [...NOTIFICATION_CENTER_ROOT, "recent"] as const,
	recent: (type: RecentTimelineItemTypeFilterEnum) =>
		[...NotificationCenterKeys.recentAll, type] as const,
	recentPreview: (
		categories: TimelineItemCategoryEnum[],
		dateFrom: string,
		dateTo: string,
		onlyUnsolved: boolean | undefined,
		limit: number,
	) =>
		[
			...NotificationCenterKeys.all,
			"recent-preview",
			categories,
			dateFrom,
			dateTo,
			onlyUnsolved,
			limit,
		] as const,
};
